// src/pages/HistoricalSites.jsx
import React from 'react';

const HistoricalSites = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Historical Sites Overview</h1>
      <p>Explore significant historical sites related to Islamic history and pilgrimages.</p>
    </div>
  );
};
export default HistoricalSites;